export class EmployeeByPlant{
    plant?:number;
    externalRefNo?:string
    unitId?:number
    trainingId?:number

    constructor(
        plant?: number,
        externalRefNo?:string,
        unitId?:number,
        trainingId?:number
    ) {
        this.plant = plant;
        this.externalRefNo =externalRefNo
        this.unitId = unitId
        this.trainingId =trainingId
    }
}